import { render, staticRenderFns } from "./AfterSalesOrderImportUpdate.vue?vue&type=template&id=96eb37c6&scoped=true&"
import script from "./AfterSalesOrderImportUpdate.vue?vue&type=script&lang=js&"
export * from "./AfterSalesOrderImportUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesOrderImportUpdate.vue?vue&type=style&index=0&id=96eb37c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eb37c6",
  null
  
)

export default component.exports